/**
 * Clerk shim — provides safe no-op stubs so the app renders without auth
 * when VITE_CLERK_PUBLISHABLE_KEY is not set.
 */

// Stub types matching Clerk's API surface used in this project
const noopUser = { user: null, isLoaded: true, isSignedIn: false };
const noopAuth = { getToken: async () => null, isSignedIn: false, signOut: async () => {} };
const noopClerk = { signOut: async () => {} };

export const useUser: any = () => noopUser;
export const useAuth: any = () => noopAuth;
export const useClerk: any = () => noopClerk;
export const SignIn: any = () => null;
export const SignUp: any = () => null;
